export enum CustomerStatementEntryType {
	Invoice = 10,
	Payment = 20,
	CreditNote = 30,
}

export class CustomerStatementEntryDto {
	public date: Date = new Date();
	public type: CustomerStatementEntryType = CustomerStatementEntryType.Invoice;
	public referenceId: number = 0;
	public orderId: number | null = null;
	public description: string = "";
	public debit: number = 0;
	public credit: number = 0;
	public balance: number = 0;
}

export class CustomerStatementDto {
	public customerId: number = 0;
	public currency: string = "";
	public entries: CustomerStatementEntryDto[] = new Array<CustomerStatementEntryDto>();
	public closingBalance: number = 0;
}
